export default __webpack_public_path__ + "static/media/NewPict1.5cda931c.png";